module.exports = __webpack_public_path__ + "static/media/web-services-icon.6bacbaad.svg";